/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import CompanyData from "layouts/tables/data/companyTableData";
import { useEffect, useState } from "react";

function Company() {
  const { sales, tasks } = reportsLineChartData;

  const [list, setList] = useState([]);

  const CompanyLists = () => {
    return (
      <MDBox p={0}>
        <CompanyData></CompanyData>
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Employer Management" />
      <MDBox py={3}>
        <CompanyLists />
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default Company;
